import { FilterRequestParams } from '../services/models/filter-request.model';

export class GetFilter {
  static readonly type = '[Filters] Get Filter';

  constructor(public filterName: string, public params: FilterRequestParams) { }
}

export class ClearFilter {
  static readonly type = '[Filters] Clear Filter';
}
